import { memo, useState } from 'react';
import { Button, Tooltip } from '@mantine/core';
import { Plus } from 'lucide-react';

interface EnhancedAddButtonProps {
  onOpen: () => void;
  loading?: boolean;
  disabled?: boolean;
  variant?: 'filled' | 'light' | 'outline';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  label?: string;
  tooltip?: string;
}

export const EnhancedAddButton = memo<EnhancedAddButtonProps>(
  ({
    onOpen,
    loading = false,
    disabled = false,
    variant = 'filled',
    size = 'sm',
    label = 'Add Product',
    tooltip = 'Add a new product to this user',
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    const buttonContent = (
      <Button
        variant={variant}
        size={size}
        onClick={onOpen}
        disabled={disabled || loading}
        loading={loading}
        leftSection={<Plus size={16} />}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          transition: 'all 0.2s ease',
          transform: isHovered ? 'translateY(-1px)' : 'translateY(0)',
          boxShadow: isHovered
            ? '0 4px 12px rgba(0, 0, 0, 0.15)'
            : '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        {label}
      </Button>
    );

    if (tooltip) {
      return (
        <Tooltip label={tooltip} position='top' withArrow>
          {buttonContent}
        </Tooltip>
      );
    }

    return buttonContent;
  }
);

EnhancedAddButton.displayName = 'EnhancedAddButton';
